import { cva } from "class-variance-authority";
import React from "react";
import { cn } from "../../lib/utils";

// Apple-style controls: capsule shape, 44pt minimum height, restrained
// press feedback, no hover bounce. Focus ring uses the semantic accent.
const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-full text-[15px] font-medium min-h-[44px] transition-all duration-200 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface disabled:pointer-events-none disabled:opacity-40",
  {
    variants: {
      variant: {
        default: "bg-accent text-white hover:bg-accent-hover",
        outline:
          "border border-separator bg-transparent text-accent-text hover:bg-black/[0.04] dark:hover:bg-white/[0.06]",
        ghost: "text-accent-text hover:bg-black/[0.04] dark:hover:bg-white/[0.06]",
        link: "rounded-none text-accent-text hover:opacity-70",
      },
      size: {
        default: "px-5 py-2.5",
        sm: "px-4 py-2 text-[13px]",
        lg: "px-8 py-3",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export function Button({ className, variant, size, ...props }) {
  return (
    <button
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}
